'use client'

import { useEffect, useState } from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export function CookieBanner() {
  const pathname = usePathname()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted')
    if (!accepted) setVisible(true)
  }, [])

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true')
    setVisible(false)
  }

  // Ocultar SOLO en fichas de producto y categorías específicas
  const isProductDetail = pathname?.startsWith('/productos/')

  const isCategoryDetail =
    pathname?.startsWith('/categorias/') && pathname !== '/categorias'

  if (isProductDetail || isCategoryDetail) return null

  if (!visible) return null

  return (
    <div
      className='
        fixed bottom-0 inset-x-0 z-50
        bg-[#F4F6EF]
        border-t border-[#E6E2D6]
        px-4 py-3 md:px-8
      '
    >
      <div className='max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3'>
        <p className='text-xs md:text-sm text-[#736A47] text-center md:text-left leading-relaxed'>
          Usamos cookies propias para mejorar la experiencia de navegación. Al
          continuar, entendés y aceptás su uso.{' '}
          <Link href='/privacidad' className='underline hover:text-[#7D744F]'>
            Política de privacidad
          </Link>
        </p>

        <button
          onClick={acceptCookies}
          className='
            text-sm text-[#736A47]
            border border-[#D8D3C4]
            rounded-md
            px-4 py-2
            hover:bg-[#EFEDE6]
            transition
            whitespace-nowrap
          '
        >
          Entendido
        </button>
      </div>
    </div>
  )
}
